import { Subject } from "rxjs";
import { useState, useEffect } from "react";

export const spinnerSubject = new Subject();

/**
*  mostraSpinner
*  @description function that is used to display the spinner       
*/
export const mostraSpinner = () => {
    spinnerSubject.next(true);
};

/**
*  nascondiSpinner
*  @description function that is used to hide the spinner         
*/
export const nascondiSpinner = () => {
    spinnerSubject.next(false);
};


const useLoaderHook = () => {
    const [contatoreSpinner, setContatoreSpinner] = useState(0);

    useEffect(() => {
        spinnerSubject.subscribe(isCaricamentoInCorso => {
            let contatore;
            if (isCaricamentoInCorso) {
                if (contatoreSpinner === 0) {
                    contatore = contatoreSpinner + 1;
                } else {
                    contatore = contatoreSpinner;
                }
            } else {
                if (contatoreSpinner === 0) {
                    contatore = contatoreSpinner;
                } else {
                    contatore = contatoreSpinner - 1;
                }
            }
            /** const contatore = isCaricamentoInCorso ? contatoreSpinner === 0 ? contatoreSpinner + 1 : contatoreSpinner : contatoreSpinner === 0 ? contatoreSpinner : contatoreSpinner - 1;  */
            setContatoreSpinner(contatore);
        });
    }, [contatoreSpinner]);

    return {
        mostraSpinner,
        nascondiSpinner,
        contatoreSpinner,
    };

};

export default useLoaderHook;
